import i18n from '@shared/utils/i18n';

export const emailRules = {
  required: 'Email is required',
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: i18n.t('validation.invalidEmail'),
  },
};

export const signInPasswordRules = {
  required: 'Password is required',
};

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

// Must stay in sync with COMPLIANT_PASSWORD_REGEX in call-agent-api
// (src/libs/validators/is-compliant-password.validator.ts).
export const PASSWORD_REGEX =
  /^(?=.{8,128}$)(?:(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{}|'])|(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{}|'])|(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{}|']))[\s\S]+$/;

const collectOtherIdentifiers = (formValues: unknown): string[] => {
  const values = formValues as Record<string, unknown> | undefined;
  if (!values) return [];

  const identifiers: string[] = [];
  if (typeof values.email === 'string') identifiers.push(values.email);
  if (typeof values.userLogin === 'string') identifiers.push(values.userLogin);

  if (Array.isArray(values.users)) {
    values.users.forEach((user) => {
      const u = user as Record<string, unknown>;
      if (typeof u?.userLogin === 'string') identifiers.push(u.userLogin);
      if (typeof u?.email === 'string') identifiers.push(u.email);
    });
  }

  return identifiers;
};

export const passwordRules = {
  required: 'Password is required',
  minLength: {
    value: PASSWORD_MIN_LENGTH,
    message: i18n.t('validation.passwordMinLength'),
  },
  maxLength: {
    value: PASSWORD_MAX_LENGTH,
    message: i18n.t('validation.passwordMaxLength'),
  },
  validate: (value: string, formValues?: unknown) => {
    if (!PASSWORD_REGEX.test(value)) {
      return i18n.t('validation.passwordSpecialCharacter');
    }

    const isSameAsIdentifier = collectOtherIdentifiers(formValues).some(
      (identifier) => identifier.toLowerCase() === value.toLowerCase(),
    );

    if (isSameAsIdentifier) {
      return i18n.t('validation.passwordMatchesIdentifier');
    }

    return true;
  },
};
